module.exports = __webpack_public_path__ + "files/49679899964b040f7146bb906dadce6d.png";